import {AfterViewInit, Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {UntypedFormGroup} from "@angular/forms";
import {icon, Layer, MapOptions, marker, tileLayer} from "leaflet";
import {Instance} from 'tippy.js';

@Component({
    selector: 'app-core-channel-offer-view-preview',
    templateUrl: './channel-offer-view-preview.component.html',
    styleUrls: ['./channel-offer-view-preview.component.scss'],
    standalone: false
})
export class ChannelOfferViewPreviewComponent implements OnInit, AfterViewInit {

    @Input() styleForm: UntypedFormGroup;

    @ViewChild('styles', { static: true }) stylesRef: ElementRef<HTMLDivElement>;

    @ViewChildren('accordion') accordionElements: QueryList<ElementRef<HTMLDivElement>>;

    public mapOptions: MapOptions;

    public mapInitialized: boolean = false;

    constructor() {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {

        setTimeout((): void => {

            this._initMap();
        });

        this._initAccordions();

        this._handleStyles();

        this.styleForm.valueChanges.subscribe((): void => {

            this._handleStyles();
        });
    }

    private _initMap(): void {

        this.mapOptions = {
            layers: [
                tileLayer('https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a>',
                    minZoom: 1,
                    maxZoom: 18
                })
            ],
            zoom: 5,
            center: {
                lat: 46.85,
                lng: 2.3518
            }
        };

        this.mapInitialized = true;
    }

    private _initAccordions(): void {

        this.accordionElements.forEach((elementRef: ElementRef<HTMLDivElement>): void => {

            const headerElement: HTMLElement = elementRef.nativeElement.querySelector('.accordion_header');

            headerElement.onclick = (): void => {

                elementRef.nativeElement.classList.toggle('open');
            };
        });
    }

    private _handleStyles(): void {

        const container: HTMLDivElement = (this.stylesRef.nativeElement as HTMLDivElement);

        while(container.firstChild){

            container.removeChild(container.firstChild);
        }

        const styleContainer = document.createElement('style');

        styleContainer.innerHTML = `
            .channel_pim_preview .title_offer .infos .offer_type:before {
                color: ${ this.styleForm.get('colorSubTitle').value } !important;
            }
            .channel_pim_preview .title_offer .infos .offer_type:after {
                background-color: ${ this.styleForm.get('colorSubTitle').value } !important;
            }
            .channel_pim_preview .txt_offer .interest span:before {
                color: ${ this.styleForm.get('colorHighlighting').value } !important;
            }
            .channel_pim_preview .infos_program .slider_program .swiper-wrapper .swiper-slide .content_program:after {
                border: 1px solid ${ this.styleForm.get('colorHighlighting').value } !important;
            }
            .channel_pim_preview .btn_cta:hover {
                background-color: ${ this.styleForm.get('colorHighlighting').value } !important;
            }
        `;

        container.appendChild(styleContainer);
    }

    public tooltipStyle: (instance: Instance) => void = (instance: Instance): void => {

        const div: HTMLDivElement = instance.popper.querySelector('.tippy-content');
        const p: HTMLElement = div.querySelector('p');

        Object.assign(div.style, {background: this.styleForm.get('colorBackgroundButton').value});
        Object.assign(p.style, {color: this.styleForm.get('colorTextButton').value});
    };

    public rgbaToHex(color: string): string {

        let r: number, g: number, b: number;

        if (color.startsWith('#')) {
            // Hexadecimal
            let hex = color.replace('#', '');
            if (hex.length === 3) {
                // #RGB -> #RRGGBB
                hex = hex.split('').map(c => c + c).join('');
            } else if (hex.length === 8) {
                // Ignorer l'alpha si présent (#RRGGBBAA)
                hex = hex.slice(0, 6);
            }

            r = parseInt(hex.slice(0, 2), 16);
            g = parseInt(hex.slice(2, 4), 16);
            b = parseInt(hex.slice(4, 6), 16);
        } else {
            // RGBA
            const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
            if (!match) {
                throw new Error('Format de couleur invalide');
            }
            r = parseInt(match[1], 10);
            g = parseInt(match[2], 10);
            b = parseInt(match[3], 10);
        }

        return `rgba(${r}, ${g}, ${b}, 0.1)`;
    }

    get marker(): Layer {

        return marker({lat: 46.85, lng: 2.3518}, {
            icon: icon({
                iconSize: [ 29, 45 ],
                iconAnchor: [ 16, 25 ],
                iconUrl: 'assets/images/icons/marker-icon-first.svg',
                shadowUrl: null
            })
        });
    }
}
